var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7a05582f\",\"hasScoped\":false}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./bottom_bar.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/client/components/components/bottom_bar.vue
// module id = 882
// module chunks = 1